<template>
    <section class="section">
        <div class="spring spring--narrow">
            <div class="js-component-component component__component" data-component="world-traveller-bundle">
                <!-- new implementation start -->
                <div class="bundle">
                    <div v-if="this.$router.currentRoute.fullPath !== '/?info=cartela'">
                        <p class="tag tag--green" v-if="['AE', 'AR', 'BH', 'BD', 'BR', 'CL', 'CN', 'CO', 'DO', 'GE', 'IQ', 'IM', 'JM', 'JO', 'KZ', 'MX', 'MC', 'ME', 'PS', 'PE', 'PR', 'RU', 'SA', 'LK', 'TW', 'UA', 'UY', 'TR'].indexOf($root.selectedCountry.countryCodeISO) !== -1">
                            <span class="visually-hidden">Recomandat</span>
                            <span class="tag__label">Recomandat</span>
                        </p>
                    </div>
                    <h3 class="visually-hidden">Oferta</h3>
                    <div class="bundle__summary">
                        <div class="bundle-data bundle-data--small bundle-data--red bundle-data__value--small" v-if="['AE', 'AR', 'BH', 'BD', 'BR', 'CL', 'CN', 'CO', 'DO', 'GE', 'IQ', 'IM', 'JM', 'JO', 'KZ', 'MX', 'MC', 'ME', 'PS', 'PE', 'PR', 'RU', 'SA', 'LK', 'TW', 'UA', 'UY', 'TR'].indexOf($root.selectedCountry.countryCodeISO) !== -1">
                            <div class="bundle-data__value bundle-data__value">
                                <span class="visually-hidden">Include</span>
                                <div class="bundle-data__heading" tabindex="0">
                                    <span class="bundle-data__amount" v-bind:class="{ shrinked: toggle_prepaid_extins_4 }">2</span>
                                    <span class="bundle-data__unit">GB</span>
                                </div>
                                date în non-SEE
                            </div>
                            <div class="bundle-data__value bundle-data__value bundle-data--red bundle-data__value--small bundle-data__value--l-border">
                                <div class="bundle-data__heading">
                                    <span class="bundle-data__amount">100</span>
                                </div>
                                minute/SMS-uri în non-SEE
                            </div>
                        </div>
                        <div class="bundle-data bundle-data--small bundle-data--red bundle-data__value--small" v-else>
                            <div class="bundle-data__value bundle-data__value">
                                <span class="visually-hidden">Include</span>
                                <div class="bundle-data__heading" tabindex="0">
                                    <span class="bundle-data__amount" v-bind:class="{ shrinked: !toggle_prepaid_extins_4 }">50.490</span>
                                    <span class="bundle-data__unit">MB</span>
                                </div>
                                date roaming <br />
                                în SEE
                            </div>
                            <div class="bundle-data__value bundle-data__value bundle-data--red bundle-data__value--small bundle-data__value--l-border">
                                <div class="bundle-data__heading">
                                    <span class="bundle-data__amount">2.000</span>
                                </div>
                                minute naționale <br />
                                și în roaming în SEE
                            </div>
                        </div>
                        <div class="bundle-title">
                            <div class="bundle-title__row">
                                <h4 class="heading heading--4 heading--light heading--leading heading--trailing">
                                    Oferta
                                    <strong>40</strong>
                                </h4>
                            </div>
                        </div>
                        <p class="bundle-price">
                            <span class="visually-hidden">Costul pachetului</span>
                            <strong class="bundle-price__cost">40€ <span class="heading--4 heading--light heading--leading heading--trailing">credit</span></strong>
                            <span class="offer-validity--text">28 de zile valabilitate</span>
                        </p>
                    </div>
                    <div data-js="_accordion" data-classes="active=show-more__heading--active" class="js-accordion show-more">
                        <div class="js-accordion-content show-more__content" v-show="toggle_prepaid_extins_4">
                            <p class="visually-hidden">Include</p>
                            <p class="text-center">
                                <span class="tooltip__info-text">Beneficii în Spatiul Economic European (SEE)</span>
                                <span class="tooltip-img" data-tippy-content="Țările SEE: Austria, Azore, Belgia, Bulgaria, Cehia, Cipru, Croația, Danemarca, Estonia, Finlanda, Franța, Germania, Grecia, Guadelupa, Guyana Franceză, Insula Sfântul Martin, Insulele Åland, Insulele Canare, Insulele Reunion, Irlanda, Islanda, Italia, Letonia, Liechtenstein, Lituania, Luxemburg, Madeira, Malta, Martinica, Mayotte, Norvegia, Olanda, Polonia, Portugalia, Slovacia, Slovenia, Spania, Suedia, Ungaria"></span>
                            </p>
                            <ul class="list list--reset bundle__inclusions">
                                <li class="bundle__inclusion bundle__small-padding flush--top">
                                    <img src="https://static.vodafone.ro/roaming/images/v546124.png" alt class="icon bundle__inclusion-bullet" />
                                    <strong>50.49 GB</strong>
                                    date în roaming SEE din nelimitat internet național
                                </li>
                                <li class="bundle__inclusion bundle__small-padding">
                                    <img src="https://static.vodafone.ro/roaming/images/v546117.png" alt class="icon bundle__inclusion-bullet" />
                                    <strong>2.000 min</strong>
                                    na&#355;ionale și în roaming SEE
                                    <span class="tooltip-img" data-tippy-content="din care 1000 min internaționale pe mobil"></span>
                                </li>
                                <li class="bundle__inclusion bundle__small-padding">
                                    <img src="https://static.vodafone.ro/roaming/images/v546152.png" alt class="icon bundle__inclusion-bullet" />
                                    <strong>300 SMS-uri</strong>
                                    na&#355;ionale și în roaming în SEE
                                </li>
                            </ul>
                            <p class="text-center">
                                <span class="tooltip__info-text"
                                    >Beneficii în afara Spațiului Economic European <br />
                                    (non-SEE)</span
                                >
                                <!-- <img src="https://static.vodafone.ro/roaming/images/v546127.png" class="icon icon__info-circle" alt> -->
                                <!-- data-tippy-content="Țările din afara Spațiului Economic European (SEE) pentru Oferta 40 cu roaming: Arabia Saudită, Argentina, Australia, Bahrain, Bangladesh, Brazilia, Canada, Chile, China, Columbia, Elveția, Republica Dominicană, Georgia, Iraq, Insula Man, Jamaica, Hong Kong, India, Indonezia, Israel, Iordania, Japonia, Jersey, Kazakhstan, Kenya, Kuweit, Macedonia, Malaezia, Mexic, Republica Moldova, Monaco, Muntenegru, Palestina, Peru, Puerto Rico, Qatar, Rusia, Serbia, Singapore, Sri Lanka, Thailanda, Taiwan, Turcia, Ucraina, Uruguay, USA, Vietnam" -->
                                <span
                                    class="tooltip-img"
                                    data-tippy-content="Țările din afara Spațiului Economic European (SEE) pentru Oferta 40 cu roaming: Australia, Hong Kong, India, Indonesia, Israel, Japonia, Jersey, Kenya, Kuweit, Malaezia, Republica Moldova, Qatar, Macedonia, Serbia, Singapore, Elvetia, Emiratele Arabe Unite, Thailanda, Turcia, Vietnam, Argentina, Bahrain, Bangladesh, Brazilia, Canada, Chile, China, Columbia, Republica Dominicana, Georgia, Iraq, Insula Man, Jamaica, Iordania, Kazakhstan, Mexic, Monaco, Montenegro, Palestina, Peru, Puerto Rico, Rusia, Arabia Saudita, Sri Lanka, Taiwan, Ucraina, Uruguay, USA, Marea Britanie"
                                ></span>
                            </p>
                            <ul class="list list--reset bundle__inclusions">
                                <li class="bundle__inclusion bundle__small-padding flush--top">
                                    <img src="https://static.vodafone.ro/roaming/images/v546124.png" alt class="icon bundle__inclusion-bullet" />
                                    <strong>2 GB</strong> date roaming
                                </li>
                                <li class="bundle__inclusion bundle__small-padding">
                                    <img src="https://static.vodafone.ro/roaming/images/v546117.png" alt class="icon bundle__inclusion-bullet" />
                                    <strong>200</strong> minute / SMS-uri efectuate și primite
                                </li>
                            </ul>
                            <p class="text-center">
                                <span class="tooltip__info-text">Beneficii exclusiv naționale</span>
                                <!-- <img src="https://static.vodafone.ro/roaming/images/v546127.png" class="icon icon__info-circle" alt> -->
                            </p>
                            <ul class="list list--reset bundle__inclusions">
                                <li class="bundle__inclusion bundle__small-padding">
                                    <img src="https://static.vodafone.ro/roaming/images/v546136.png" alt class="icon bundle__inclusion-bullet" />
                                    <strong>Nelimitat</strong> minute și SMS-uri în re&#355;ea
                                </li>
                            </ul>
                        </div>

                        <button-more @click.native="toggle_prepaid_extins_4 = !toggle_prepaid_extins_4" :more="toggle_prepaid_extins_4" prefix="Arată mai"></button-more>
                    </div>
                    <div class="bundle__select bundle__select--first">
                        <a :href="hrefActivate" class="button button--secondary button--full-width"> Activează opțiunea </a>
                    </div>
                </div>
                <!-- new implementation end -->
            </div>
        </div>
    </section>
</template>

<script>
import ButtonMore from './ButtonMore.vue';
export default {
    name: 'OfferPrepaid_35',
    components: {
        ButtonMore,
    },
    data() {
        return {
            toggle_offer: false,
            toggle_prepaid_extins_4: false,
            recommended_offer: false,
            hrefActivate: this.$root.hrefActivate,
        };
    },
    methods: {
        expand() {
            this.toggle_offer = true;
        },
        recommended_check() {
            if (this.$root.selectedCountry !== null) {
                if (['AR', 'BH', 'BD', 'BR', 'CL', 'CN', 'CO', 'DO', 'GE', 'IQ', 'IM', 'JM', 'JO', 'KZ', 'MX', 'MC', 'ME', 'PS', 'PE', 'PR', 'RU', 'SA', 'LK', 'TW', 'UA', 'UY', 'TR'].indexOf(this.$root.selectedCountry.countryCodeISO) !== -1) {
                    this.recommended_offer = true;
                    this.toggle_prepaid_extins_4 = true;
                    // console.log('it has a recommended offer ' + this.recommended_offer);
                } else {
                    this.recommended_offer = false;
                    this.toggle_prepaid_extins_4 = false;
                    // console.log('it does not have a recommended offer ' + this.recommended_offer);
                }
            }
        },
    },
    mounted() {
        this.$root.$on('prepare-for-pdf', this.expand);
        tippy('[data-tippy-content]', {
            arrow: true,
        });
        this.$nextTick(() => {
            this.recommended_check();
        });
    },
    beforeDestroy() {
        this.$root.$off('prepare-for-pdf', this.expand);
    },
};
</script>
